/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import ReactPaginate from "react-paginate";
import {
  addCategory,
  deleteBoard,
  getCategoryList,
  updateCategory,
} from "../../redux/slices/QuestionSlice";
import { useDispatch, useSelector } from "react-redux";
import { showErrorToast, showSuccessToast } from "../../components/Toast/Toast";
import Loading from "../../components/Loader/Loader";
import ModalDefault from "../../components/ModalReport/Modal";
import { validationMessages } from "../../utils/ContantsMeassages";
import { FiChevronLeft, FiChevronRight, FiTrash2 } from "react-icons/fi";
import GlobalSearchFilter from "../../components/Atoms/Global search/GlobalSearch";
import Table from "../../components/Atoms/Tables";
import { AiOutlineEdit } from "react-icons/ai";

const CategoryManagement = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [errorCreate, setErrorCreate] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [errorUpdate, setErrorUpdate] = useState({});
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);
  const [searchText, setSearchText] = useState("");
  const size = 10;
  const selector = useSelector((state) => state.question);
  const getCategoryListData = selector?.getCategoryListData;
  console.log("This is getcategory list data", getCategoryListData);
  useEffect(() => {
    const reqData = {
      keyWord: searchText,
      pageNo: page + 1,
      size: size,
    };
    dispatch(getCategoryList(reqData));
  }, [size, isRefresh, page, searchText]);
  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = {};
    if (!formData.name || formData.name.trim() === "") {
      errors.name = validationMessages.NAME;
    }

    if (!formData.description || formData.description.trim() === "") {
      errors.description = validationMessages.SHORT_NAME;
    }

    if (Object.keys(errors).length > 0) {
      setErrorCreate(errors);
      return;
    }

    setErrorCreate({});
    const reqData = {
      name: formData.name.trim(),
      description: formData.description.trim(),
    };

    dispatch(addCategory(reqData))
      .unwrap()
      .then((res) => {
        if (res?.error) {
          showErrorToast(res.message || "Something went wrong!");
          return;
        }

        showSuccessToast("Category Data Added Successfully!!");
        setIsOpen(false);
        setFormData({});
        setIsRefresh(!isRefresh);
      })
      .catch((err) => {
        console.log("error", err);
        showErrorToast("Error in Adding Category Data");
      });
  };

  const handleDelete = (boardId) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="bg-white p-6 rounded-lg shadow-md max-w-md mx-auto text-center border border-gray-200">
            <div className="flex justify-center mb-4">
              <div className="w-12 h-12 rounded-full flex items-center justify-center bg-gray-100">
                <FiTrash2 className="text-red-400" size={24} />
              </div>
            </div>
            <p className="text-gray-700 mb-6">
              Are you sure you want to delete this Board?
            </p>
            <div className="flex justify-center space-x-2">
              <button
                className="px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded text-gray-700 font-medium text-sm"
                onClick={onClose}
              >
                No, cancel
              </button>
              <button
                className="px-4 py-2 bg-red-600 hover:bg-red-700 rounded text-white font-medium text-sm"
                onClick={async () => {
                  try {
                    setIsLoading(true);
                    const res = await dispatch(
                      deleteBoard({ id: boardId?.id })
                    ).unwrap();
                    showSuccessToast(res?.message);
                    setIsRefresh((prev) => !prev);
                  } catch (error) {
                    showErrorToast(
                      error?.message || "Failed to delete Board Data"
                    );
                  } finally {
                    setIsLoading(false);
                    onClose();
                  }
                }}
              >
                Yes, I'm sure
              </button>
            </div>
          </div>
        );
      },
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleUpdateChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmitUpdate = (e) => {
    e.preventDefault();

    const payload = {
      ...formData,
    };

    dispatch(updateCategory(payload))
      .unwrap()
      .then((res) => {
        if (res.error) {
          showErrorToast(res.message);
          return;
        } else {
          showSuccessToast("Category Data Updated Successfully");
          setIsOpenUpdate(false);
          setIsRefresh(!isRefresh);
        }
      })
      .catch((error) => {
        console.log("error", error);
        showErrorToast("Error in Updating Category Data");
      });
  };
  return (
    <>
      <Loading loading={isLoading || selector?.loading} />
      <div className=" w-full overflow-y-scroll py-3 md:px-5 px-1">
        <GlobalSearchFilter
          title={`Category Management`}
          buttonLabel={`Add Category`}
          onAddClick={() => {
            setFormData({});
            setIsOpen(true);
          }}
          showExportButton={false}
          searchKeyword={searchText}
          onSearchChange={(e) => {
            setSearchText(e.target.value);
            setPage(0);
          }}
          placeholder={`Search by name..`}
        />
        <div className="w-full h-full max-w-[100vw]">
          <Table
            headers={{
              name: "Category Name",
              description: "Description",
              action: "Action",
            }}
            list={
              getCategoryListData?.data?.categories &&
              getCategoryListData?.data.categories.length > 0 ? (
                getCategoryListData?.data.categories?.map((ele, index) => ({
                  name: ele?.name || "—",
                  description: ele?.description || "—",
                  action: (
                    <div className="mt-4 flex justify-end gap-4">
                      <button
                        onClick={() => {
                          setFormData({
                            name: ele?.name,
                            description: ele?.description,
                            id: ele?._id,
                          });
                          setIsOpenUpdate(true);
                        }}
                        className="p-2 shadow text-[#1E5EFF] border border-[#D7DBEC] rounded hover:bg-blue-100 transition-colors duration-200"
                        aria-label="Edit"
                      >
                        <AiOutlineEdit className="text-lg" />
                      </button>
                      <button
                        onClick={() => handleDelete(ele)}
                        className="p-2 shadow text-red-500 border border-[#D7DBEC] rounded hover:bg-blue-100 transition-colors duration-200"
                        aria-label="Delete"
                      >
                        <FiTrash2 className="h-4 w-4" />
                      </button>
                    </div>
                  ),
                }))
              ) : (
                <p>No Data Available</p>
              )
            }
            size={size}
            pageNo={page}
            total={0}
          />
          {getCategoryListData?.data?.total > size && (
            <div className="px-4 py-3 flex items-end justify-end border-t border-[#E6E9F4] sm:px-6">
              <ReactPaginate
                previousLabel={<FiChevronLeft className="h-5 w-5" />}
                nextLabel={<FiChevronRight className="h-5 w-5" />}
                breakLabel={"..."}
                pageCount={Math.ceil(getCategoryListData?.data?.total / size)}
                marginPagesDisplayed={1}
                pageRangeDisplayed={3}
                onPageChange={({ selected }) => setPage(selected)}
                containerClassName={"flex items-center gap-1"}
                pageClassName={"px-3 py-1 rounded-md border border-gray-300"}
                pageLinkClassName={"text-sm font-medium"}
                activeClassName={"bg-blue-500 text-white border-blue-500"}
                previousClassName={"p-1 rounded-md border border-gray-300"}
                nextClassName={"p-1 rounded-md border border-gray-300"}
                disabledClassName={"opacity-50 cursor-not-allowed"}
                forcePage={page}
                size={size}
              />
            </div>
          )}
        </div>
      </div>

      <ModalDefault
        isOpen={isOpen}
        title="Add Category"
        closeModal={() => {
          setIsOpen(false);
          setErrorCreate({});
          setFormData({});
        }}
      >
        <div className="">
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label
                className="block text-sm font-medium text-gray-700 mb-1"
                htmlFor="name"
              >
                Category Name:
              </label>
              <input
                type="text"
                id="name"
                maxLength={50}
                name="name"
                value={formData.name || ""}
                onChange={handleChange}
                className="border border-gray-300 rounded-md p-2 w-full focus:outline-none focus:border-blue-500"
                placeholder="Enter Category Name (Full Form)"
              />
              {errorCreate && errorCreate["name"] && (
                <div className=" text-sm text-red-500">{errorCreate.name}</div>
              )}
            </div>

            <div className="mb-4">
              <label
                className="block text-sm font-medium text-gray-700 mb-1"
                htmlFor="description"
              >
                Description Name:
              </label>
              <input
                type="text"
                id="description"
                maxLength={20}
                name="description"
                value={formData.description || ""}
                onChange={handleChange}
                className="border border-gray-300 rounded-md p-2 w-full focus:outline-none focus:border-blue-500"
                placeholder="Enter Education Name (CBSE/ICSE/...)"
              />
              {errorCreate && errorCreate["description"] && (
                <div className=" text-sm text-red-500">
                  {errorCreate.description}
                </div>
              )}
            </div>
            <button
              type="submit"
              className="bg-blue-500 w-full text-white px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none focus:bg-blue-600"
            >
              Submit
            </button>
          </form>
        </div>
      </ModalDefault>

      <ModalDefault
        isOpen={isOpenUpdate}
        title="Update Category"
        closeModal={() => {
          setIsOpenUpdate(false);
          setErrorUpdate({});
        }}
      >
        <div className="">
          <form onSubmit={handleSubmitUpdate}>
            <div className="mb-4">
              <label
                className="block text-sm font-medium text-gray-700 mb-1"
                htmlFor="name"
              >
                Category Name:
              </label>
              <input
                type="text"
                id="name"
                maxLength={50}
                name="name"
                value={formData.name}
                onChange={handleUpdateChange}
                className="border border-gray-300 rounded-md p-2 w-full focus:outline-none focus:border-blue-500"
              />
              {errorUpdate && errorUpdate["name"] && (
                <div className=" text-sm text-red-500">{errorUpdate.name}</div>
              )}
            </div>

            <div className="mb-4">
              <label
                className="block text-sm font-medium text-gray-700 mb-1"
                htmlFor="description"
              >
                Description: Name:
              </label>
              <input
                type="text"
                id="description"
                name="description"
                value={formData.description || ""}
                onChange={handleUpdateChange}
                className="border border-gray-300 rounded-md p-2 w-full focus:outline-none focus:border-blue-500"
              />
              {errorUpdate && errorUpdate["description"] && (
                <div className=" text-sm text-red-500">
                  {errorUpdate.description}
                </div>
              )}
            </div>
            <button
              type="submit"
              className="bg-blue-500 w-full text-white px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none focus:bg-blue-600"
            >
              Submit
            </button>
          </form>
        </div>
      </ModalDefault>
    </>
  );
};

export default CategoryManagement;
